import { deletePresentacion, getPresentacionesPanel } from "../../services/PresentacionesServices";
import { PresentacionesContext } from "./PresentacionesContext"


export const PresentacionesState = ({ children }) => {
    const getPresentacionesPanelData = async (search, numpag, filas) => {
        let res = await getPresentacionesPanel(search, numpag, filas)
        return res;
    }

    const deletePresentacionData = async (body,search, numpag, filas) => {
        const res = await deletePresentacion(body)
        if (res) getPresentacionesPanelData(search, numpag, filas)
        return res
    }

    return <PresentacionesContext.Provider value={{
        deletePresentacionData,
        getPresentacionesPanelData,
    }} >
        {children}
    </PresentacionesContext.Provider>
}